import {ListReducerBuilder} from '../../../../utils/reducers';
import {IDENTIFIER} from '../actions';

export default {
    companies: ListReducerBuilder.build(IDENTIFIER, false)
};
